import LazyLoad from "@/utils/AsyncRouteHelper";
/*
import ApplicationRoutes from "./routes/applications";
import VuseRoutes from "./routes/vuse";
import VuetifyRoutes from "./routes/vuetify";*/
import iBookRoutes from "./routes/iBook";
//console.log(iBookRoutes);
/*const AppSidebar = () =>
  import(

    "@/layouts/App/Sidebar"
  );
  */
const AppToolbar = () =>
  import(
    /* webpackChunkName: "Vusenavs", webpackPreload: true */ 
    "@/layouts/App/Toolbar"
  );
   /*
const UnsignedToolbar= () =>
  import(
    // webpackChunkName: "Vusenavs", webpackPreload: true
    "@/layouts/App/UnsignedToolbar"
  );
 
const UnsignedSidebar= () =>
  import(
    
    "@/layouts/App/UnsignedSidebar"
  );
const BossSidebar= () =>
  import(
    
    "@/layouts/App/BossSidebar"
  );
*/
const AppFooter = () =>
  import(
    /* webpackChunkName: "Vusenavs",  webpackPreload: true */ 
    "@/layouts/App/Footer"
  );

const AllRoutes = [ ...iBookRoutes];
const routes = AllRoutes.map((route) => {
const { params, defaultComponentPath, navs, unsignednavs, bossnavs } = route;
const componentObj = navs ? {
        components: {
          default: LazyLoad(defaultComponentPath),
          //sidebar: AppSidebar,
          header: AppToolbar,
          footer: AppFooter,
        },
      }
    : unsignednavs ?{
		components: {
			default: LazyLoad(defaultComponentPath),
			//sidebar: UnsignedSidebar,
			//header: UnsignedToolbar,
			footer: AppFooter,
        },
	}: bossnavs ?{
		components: {
			default: LazyLoad(defaultComponentPath),
			//sidebar: BossSidebar,
			header: AppToolbar,
			footer: AppFooter,
        },
  }:
	{
    component: LazyLoad(defaultComponentPath),
    };
  return {
    ...params,
    ...componentObj,
  };
});

export default [{ path: "/", redirect: "/ " }, ...routes];
//export default [routes];
